import { default as startCase } from 'lodash/startCase'

export default function (pathname) {
  return startCase(pathname.split('/').pop())
}
